import React, { Fragment } from 'react';
import styles from '../ConsentDetailsPopup/index.styl';
import Icon from '../../../../Icon';

export function renderConsentHeader(
  formatMessage,
  titleTypeConsent,
  organizationName,
  serviceName,
  dateConsent,
  mainConsent,
  mainTitle,
) {
  const fullTitleService = formatMessage(
    {
      id: 'appointment.consent.consentFor',
    },
    { organizationName, serviceName },
  );
  return mainConsent ? (
    <div className={styles.consentMainTitle}>{mainTitle}</div>
  ) : (
    <Fragment>
      <div className={styles.headerLeftSide}>
        <Icon name="icon-consent" size={36} className={styles.icon} />
        <div className={styles.consentDetails}>
          <div className={styles.consentType}>{titleTypeConsent}</div>
          <div className={styles.consentService}>{fullTitleService}</div>
          <div className={styles.dateConsent}>{dateConsent}</div>
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/utils/renderConsentHeader.jsx